export const PAY_DETAIL_FIELDS = {
  CONTRACT_UUID: 'contractUuid',
  AMOUNT: 'amount',
  USER_UUID: 'userUuid',
  BRANCH_UUID: 'branchUuid',
};
